/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/* eslint-disable import/prefer-default-export */

export class AutocompleteService {
    constructor(adapters) {
        if (!adapters || adapters.length === 0) {
            throw new Error(
                `At least one adapter is required for AutocompleteService`
            );
        }

        this.autocompleteAdapters = [];

        Array.from(adapters).forEach((adapter) => {
            // eslint-disable-next-line no-prototype-builtins
            if (!adapter || !adapter.hasOwnProperty('autocomplete')) {
                throw new Error(
                    `${adapter.constructor.name} is not implemented yet`
                );
            } else {
                this.registerAdapter(adapter);
            }
        });
    }

    registerAdapter(adapter) {
        this.autocompleteAdapters.push(adapter);
    }

    /**
     * Get search results.
     *
     * @param {string} args query string.
     * @param {function} mockFn Unit test mock function.
     *
     * @returns {Promise<array>} A promised list of search results.
     */
    getResults(args, mockFn) {
        return Promise.all(
            this.autocompleteAdapters.map((adapter) =>
                adapter.getResults(args, mockFn)
            )
        )
            .then((result) => {
                const mappedResults = [];
                let resultsCount = 0;
                let i = 0;

                // Match each result with its template id.
                result.map(({ data }, idx) => {
                    resultsCount += data.length;
                    mappedResults[idx] = [];
                    if (data.length) {
                        data.forEach((element) => {
                            // eslint-disable-next-line no-plusplus
                            mappedResults[idx][i++] = element;
                        });
                    }
                    return mappedResults;
                });

                return { results: mappedResults, count: resultsCount };
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.error(error);
                return { results: [], count: 0, error };
            });
    }
}
